import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {OverlaySpinnerComponent} from "@shared/components/overlay-spinner/overlay-spinner.component";
import {UserCareProgramWeek} from "@shared/api/models/query/user-care-program.model";
import {WeeklySummary} from "@shared/api/models/query/patient-statistics.model";
import {PatientStatisticsService} from "@shared/api/services/v2/patient-statistics.service";
import {
    PatientOverviewV2ChapterProgressComponent
} from "@cdss/pages/patient-overview-v2/chapter-progress/patient-overview-v2-chapter-progress.component";
import {
    PatientOverviewV2SurveysComponent
} from "@cdss/pages/patient-overview-v2/surveys/patient-overview-v2-surveys.component";
import {
    PatientOverviewV2MealPlanComponent
} from "@cdss/pages/patient-overview-v2/meal-plan/patient-overview-v2-meal-plan.component";
import {
    PatientOverviewV2AdherenceStatComponent
} from "@cdss/pages/patient-overview-v2/adherence-stat/patient-overview-v2-adherence-stat.component";

@Component({
    selector: 'cdss-patient-overview-v2-weekly-summary',
    imports: [CommonModule, OverlaySpinnerComponent, PatientOverviewV2ChapterProgressComponent, PatientOverviewV2SurveysComponent, PatientOverviewV2MealPlanComponent, PatientOverviewV2AdherenceStatComponent],
    templateUrl: './patient-overview-v2-weekly-summary.component.html',
    standalone: true,
    styleUrl: './patient-overview-v2-weekly-summary.component.scss'
})
export class PatientOverviewV2WeeklySummaryComponent {

    @Input() type = 'patient';
    @Input() careProgramId: number | null = null;
    /** ARFID signal for the carer meal plan card copy (UNIVAPLAT-3041,
     *  `resolveWeeklyCarerCopy`). Unused on the patient branch. */
    @Input() isArfid = false;

    get disabled(): boolean {
        return !this.weeklySummary
    }
    loading: boolean = false

    private _currentWeek: UserCareProgramWeek = null
    weeklySummary: WeeklySummary = null

    chapterAdherence: number = 0
    checkinAdherence: number = 0
    foodDiaryCompletion: number = 0

    constructor(
        private patientStatisticsService: PatientStatisticsService
    ) {
    }

    @Input()
    set currentWeek(week: UserCareProgramWeek) {
        if (!week) return

        this._currentWeek = week
        this.refresh()
    }
    get currentWeek(): UserCareProgramWeek {
        return this._currentWeek
    }

    async refresh() {
        this.loading = true
        this.weeklySummary = await this.patientStatisticsService.getWeeklySummary(
            this._currentWeek.patientId,
            this._currentWeek.dateStart,
            this._currentWeek.dateEnd,
            this.type
        )
        this.loading = false

        this.chapterAdherence = this.weeklySummary?.adherence.chapters.scheduled == 0? null : this.weeklySummary?.adherence.chapters.completed * 100 / this.weeklySummary?.adherence.chapters.scheduled

        this.checkinAdherence = this.weeklySummary?.adherence.checkins.scheduled == 0? null : this.weeklySummary?.adherence.checkins.completed * 100 / this.weeklySummary?.adherence.checkins.scheduled

        if (this.type == 'patient') {
            this.foodDiaryCompletion = this.weeklySummary?.adherence.foodDiary.perDay.scheduled == 0? null : this.weeklySummary?.adherence.foodDiary.perDay.completed * 100 / this.weeklySummary?.adherence.foodDiary.perDay.scheduled
        }

    }
}
